/** 將系統流程儲存版號拆成可顯示的版號及說明。 */
export function revisionParts(value) {
  const text = String(value || '');
  const match = /^v(\d+\.\d+)(?:\((估算新增|估算變更|執行|設變新增|設變|核定版|未核定版)\))?$/.exec(text);
  return match ? {number: match[1], description: match[2] || ''} : {number: text, description: ''};
}

/** 既有 A2 版次保存了估算類型，對外呈現為系統狀態。 */
export function estimateStatus(value) {
  const description = revisionParts(value).description;
  return ({'估算新增':'estimate_added','估算變更':'estimate_changed','執行':'construction_execution','設變新增':'construction_change_added','設變':'construction_change','核定版':'b_approved','未核定版':'b_unapproved'})[description] || null;
}

/** 新版在前；兩段整數比較，1.10 排在 1.9 前，舊式版號以建立時間後備。 */
export function compareRevisions(a, b) {
  const left = /^(\d+)\.(\d+)$/.exec(revisionParts(a.meta?.revision).number);
  const right = /^(\d+)\.(\d+)$/.exec(revisionParts(b.meta?.revision).number);
  if (left && right) {
    for (const index of [1, 2]) {
      const x = BigInt(left[index]), y = BigInt(right[index]);
      if (x !== y) return x > y ? -1 : 1;
    }
  }
  return String(b.addedAt || '').localeCompare(String(a.addedAt || ''))
    || String(b.id).localeCompare(String(a.id));
}
